import React from 'react';
import classes from './Checkbox.module.css';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const Checkbox = ({ value, setValue, label, disabled, labelStyle, showLabel = true }) => {
  const checkValueTypeArray = Array.isArray(value);
  const isChecked = checkValueTypeArray
    ? value?.findIndex(
        (findValue) => findValue?.id == label?.id && findValue?.quantity > 0
      )
    : value == label && label?.quantity > 0
    ? true
    : false;

  const HandleClick = () => {
    let newArray = [];
    if (checkValueTypeArray) {
      newArray = value?.slice();
      if (isChecked !== -1) {
        newArray.splice(isChecked, 1);
      } else {
        newArray.push(label);
      }
    } else {
      newArray = isChecked ? '' : label;
    }
    setValue(newArray);
  };

  return (
    <>
      <style>{`
        .${classes.container} input:disabled ~ .${classes.checkmark} {
          border: ${
            checkValueTypeArray && isChecked !== -1
              ? 0
              : checkValueTypeArray == false && isChecked == true
              ? 0
              : 2
          }px solid #4D4D4D;
          background-color: ${
            checkValueTypeArray && isChecked !== -1
              ? 'green'
              : checkValueTypeArray == false && isChecked == true
              ? 'green'
              : 'transparent'
          };
        }
      `}</style>
      <div className={`${classes.checkboxWithLabel}`}>
        <div className={`${classes.container}`}>
          <input
            type="checkbox"
            checked={
              checkValueTypeArray && isChecked !== -1
                ? 'checked'
                : checkValueTypeArray == false && isChecked == true && 'checked'
            }
            disabled={disabled}
            id={`checkbox${label}`}
          />
          <span
            className={classes.checkmark}
            onClick={() => {
              disabled !== true && HandleClick();
            }}></span>
        </div>
        {label && showLabel && (
          <label
            htmlFor={`checkbox${label}`}
            className={clsx(classes.labelText, {
              [classes.labelChecked]: isChecked !== -1 && disabled == false,
              [classes.labelDisabled]: disabled == true,
              [classes.label]: disabled == false,
            })}
            style={{
              ...labelStyle,
            }}>
            <span>{label?.id ? label?.id : label}</span>
          </label>
        )}
      </div>
    </>
  );
};

Checkbox.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.object, // Updated to expect an object to include `id` and `quantity`
  labelStyle: PropTypes.object,
  showLabel: PropTypes.bool,
};

Checkbox.defaultProps = {
  value: [],
  disabled: false,
  label: null,
  showLabel: true,
};

export default Checkbox;
